export type { AISettings } from '@/UI/Identity/aiSettings.types';
export {
  MODEL_DEFAULT_VALUE,
  MODEL_OPTIONS,
  type ModelOption,
} from '@/UI/Identity/AiModel/aiModel.constants';

// Personality enum value -> subscription config key (the plan-gating record is keyed by name)
export const PERSONALITY_OPTIONS: { value: number; key: string }[] = [
  { value: 0, key: 'normal' },
  { value: 1, key: 'humorous' },
  { value: 2, key: 'professional' },
  { value: 3, key: 'friendly' },
  { value: 4, key: 'sassy' },
  { value: 5, key: 'intelligent' },
  { value: 6, key: 'empathetic' },
  { value: 7, key: 'bold' },
  { value: 9, key: 'excited' },
  { value: 10, key: 'mysterious' },
  { value: 11, key: 'inspiring_motivational' },
  { value: 12, key: 'adventurous' },
  { value: 13, key: 'sophisticated_elegant' },
];

export const PROFESSION_OPTIONS: string[] = [
  'helpful_assistant',
  'customer_support_representative',
  'shopping_assistant',
  'field_expert',
  'interviewer',
];

export const CREATIVITY_OPTIONS = [0, 1, 2];
export const REPLY_OPTIONS = [0, 1, 2];
export const LINKS_OPTIONS = [0, 1];

export const IDENTITY_DEFAULTS = {
  personality: 0,
  profession: 'helpful_assistant',
  creativity_level: 1,
  reply_length: 1,
  url_priority: 0,
  language: 'en',
};

// Mirrors MAIN_PROMPT_LIMIT_FREE; used only until /allowed_features resolves.
export const MAIN_PROMPT_LIMIT_FALLBACK = 15000;
